import { render, staticRenderFns } from "./ReportTenanciesSettings.vue?vue&type=template&id=ff04bc5c&scoped=true&"
import script from "./ReportTenanciesSettings.vue?vue&type=script&lang=js&"
export * from "./ReportTenanciesSettings.vue?vue&type=script&lang=js&"
import style0 from "./ReportTenanciesSettings.vue?vue&type=style&index=0&id=ff04bc5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff04bc5c",
  null
  
)

export default component.exports